import { Component, OnInit ,Input, Output, EventEmitter,AfterViewInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import {  EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
// import { ConsoleReporter } from 'jasmine';
import { environment } from 'src/environments/environment'; 
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
@Component({ 
  selector: 'app-plugin-breadcrumb',
  templateUrl: './plugin-breadcrumb.component.html',
  styleUrls: ['./plugin-breadcrumb.component.css']
})
export class PluginBreadcrumbComponent implements OnInit {
  @Input() datacollection:any;
 
  constructor(private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute,public encDec:EncryptDecryptService,private route: Router,public translate: TranslateService) { }
  language:any = '';
  global_menu:any;
  hasglobal_menu:boolean=false;
  primary_menu:any;
  hasprimary_menu:boolean=false;
  secondary_menu:any;
  hassecondary_menu:boolean=false;
  tertiary_menu:any={};
  has_tertiary_menu:boolean=false;
  hasMenu:boolean = false;
  check_plugin:boolean=false;
  current_plugin:any;
  plugin_page_total_use:any=0;
  current_url_plugin:any = this.route.url.replace('/',"");

  emp_dtl:any={'title':'',titleInHindi:''};
  showEmpMen:boolean=false;
  ngOnInit(): void {
    this.language = sessionStorage.getItem('locale');//dynamic
    if(!this.datacollection.showEmpMen){
        if(this.datacollection.data.status){ 
            this.global_menu = this.datacollection.data.global_menu;
            this.primary_menu = this.datacollection.data.primary_menu;
            this.secondary_menu = this.datacollection.data.secondary_menu;
            this.hasglobal_menu = this.datacollection.data.global_menu!==false?true:false;
            this.hasprimary_menu = this.datacollection.data.primary_menu!==false?true:false;
            this.hassecondary_menu = this.datacollection.data.secondary_menu!==false?true:false;
            this.has_tertiary_menu = this.datacollection.data.tertiary_menu!==false?true:false;
            this.tertiary_menu= this.datacollection.data.tertiary_menu;
            this.hasMenu=this.datacollection.data.hasMenu;
            this.check_plugin=this.datacollection.data.check_plugin;
            this.current_plugin=this.datacollection.data.current_plugin;
            this.plugin_page_total_use=this.datacollection.data.plugin_page_total_use;
        }
    } else {
      this.showEmpMen = true;
      this.emp_dtl = this.datacollection.emp_dtl;
    }
  }











  goToPluginPage(link:any,menudtl:any)
  {
   sessionStorage.removeItem(btoa(menudtl.selectPlugin));
   sessionStorage.setItem(btoa(menudtl.selectPlugin),JSON.stringify(menudtl));
   // this.route.navigate([link,""]);
   this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
   this.route.navigate([link]));
  }





  goToExtLink(url:any)
  {
     Swal.fire({
      title: 'You are being redirected to an external website. Please note that Food Corporation of India (FCI) cannot be held responsible for external websites content & privacy policies.',
      text: 'Are you sure?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        window.open(url, '_blank');
 
    }
  });
  }


 

goToContentPage(menu:any)
{
    this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
    this.route.navigate(['./view'+'/'+menu.VCHMENUALIAS]));
 } 

}
